import * as React from 'react';
import * as L from 'leaflet';
import styled from 'styled-components';

import { MapContainer, Marker, ScaleControl } from 'react-leaflet';
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';
import { MarkerIcon } from './svg-icons/MarkerIcon';
import { App } from '../../App';
import { StandardLayerControl } from './StandardLayerControl';

interface IProps {
  className?: string;
  // Location initially shown op map. Can be null.
  lat?: number;
  lng?: number;
  // Initial zoom level.
  zoom: number;
}

//
// ShowLocationMap shows map with a single maker
// 
class ShowLocationMapBase extends React.Component<IProps> {
  private map: L.Map;

  constructor(props: IProps) {
    super(props);
  }

  // Converts current prop location to LatLngLiteral. Returns null
  // if current location is invalid.
  getLocation = (): L.LatLngLiteral => {
    if(isNaN(parseFloat(this.props.lat as any)) || isNaN(parseFloat(this.props.lng as any))) {
       return null;
    }
    return { lat: this.props.lat, lng: this.props. lng };
  }

  render() {
    let p = this.props;
    let location = this.getLocation();

    return (
      <div className={p.className}>

        <MapContainer 
          style={{ height: '100%', width: '100%' }} 
          center={location ?? [0,0]}  /* center is 0,0 if initial location not set */
          zoom={p.zoom} 
          scrollWheelZoom={false}
          attributionControl={false}
        >
          <StandardLayerControl/>
          <ScaleControl position="topleft" imperial={false}/>
          {/* Show marker for current location, if any */}
          {location && 
            <Marker position={location} icon={MarkerIcon(25, 'white')}/>}
        </MapContainer>
      </div>
    );
  }
}

const ShowLocationMap = styled(ShowLocationMapBase)`
  position: relative;
  width:    100%;
  height:   100%;
`

export { ShowLocationMap }
